import {createElement,useRef,useState} from "react";

// Export the existing transaction PDF only after the user clicks. No document
// is mounted or rendered during listing, search, modal or pagination updates.
export default function FinanceProductionPDFDownload({currentRows=[],kind="invoice",label,companyName}){
  const [busy,setBusy]=useState(false);
  const [failed,setFailed]=useState(false);
  const working=useRef(false);
  async function download(){
    if(working.current)return;
    working.current=true;setBusy(true);setFailed(false);
    try{
      const [{pdf}, {TransactionPDFDocument,transactionSummary,recordTitles}]=await Promise.all([
        import("@react-pdf/renderer"),import("./SalesPDFExport.jsx")
      ]);
      const title=recordTitles[kind]||(kind==="estimate"?"Billing Estimate":"Saved Records");
      const name=currentRows.length===1?transactionSummary(currentRows[0],kind).id:title;
      const safeName=String(name||title).replace(/[^a-zA-Z0-9._-]/g,"_");
      const blob=await pdf(createElement(TransactionPDFDocument,{data:currentRows,kind,companyName})).toBlob();
      const url=URL.createObjectURL(blob);
      const link=document.createElement("a");
      link.href=url;link.download=`${safeName}.pdf`;
      document.body.appendChild(link);link.click();link.remove();
      window.setTimeout(()=>URL.revokeObjectURL(url),60000);
    }catch(error){
      console.error("PDF export failed:",error);setFailed(true);
    }finally{working.current=false;setBusy(false);}
  }
  // Existing export styles target an anchor (including the Production toolbar).
  // Keep that element and its keyboard semantics; only defer PDF work to click.
  return <a href="#" role="button" className="controlButtons" aria-disabled={busy}
    aria-label={busy?"Preparing PDF":failed?"Retry PDF":"Export PDF"}
    onClick={event=>{event.preventDefault();if(!busy)download();}}
    onKeyDown={event=>{if(event.key===' '){event.preventDefault();if(!busy)download();}}}>
    {busy?"Preparing PDF…":failed?"Retry PDF":label||"Export PDF"}
  </a>;
}
